<div id="ui-table">
    <div id="table-title">
        <div>{{title()}}</div>
    </div>
    <div class="table-container">
        <table class="ui-table">
            <thead>
                <tr>
                    <!-- Create table headers dynamically based on columns input -->
                    @for ( column of columns(); track $index) {
                    <th [id]="'column_' + column.key" sort="asc" (click)="toggleSorting(column.key)"> {{ column.label }}
                        @if (sortColumn[0] === column.key && sortColumn[1] === 'asc') {
                        <span class="sort-icon">
                            <ng-container *ngTemplateOutlet="sortAsc"></ng-container>
                        </span>
                        }
                        @if (sortColumn[0] === column.key && sortColumn[1] === 'desc') {
                        <span class="sort-icon">
                            <ng-container *ngTemplateOutlet="sortDesc"></ng-container>
                        </span>
                        }
                        @if ((sortColumn[0] !== column.key) || sortColumn[1] === null ) {
                        <span class="sort-icon">
                            <ng-container *ngTemplateOutlet="sortNone"></ng-container>
                        </span>
                        }
                    </th>
                    }

                </tr>
            </thead>
            <tbody>
                <!-- Create table rows dynamically based on data input -->
                @for (row of data(); track $index) {
                <tr class="table-body-row">
                    @for (column of columns(); track $index) {
                    <td>
                        <ng-container
                            *ngTemplateOutlet="getTemplate(column.key) || defaultCell; context:  { $implicit: row }">
                        </ng-container>
                        <ng-template #defaultCell>
                            {{ $any(row)[column.key] ?? '---' }}
                        </ng-template>
                    </td>

                    }
                </tr>
                }
            </tbody>
        </table>
    </div>
</div>

<ng-template #sortAsc>

    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#000">
        <path d="M440-800v487L216-537l-56 57 320 320 320-320-56-57-224 224v-487h-80Z" />
    </svg>
</ng-template>

<ng-template #sortDesc>
    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#000">
        <path d="M440-160v-487L216-423l-56-57 320-320 320 320-56 57-224-224v487h-80Z" />
    </svg>
</ng-template>

<ng-template #sortNone>
    -
</ng-template>
